<template>
  <div>
    <v-dialog v-model="modal_add" persistent max-width="760px" scrollable>
      <v-card class="dialog-card">
        <!-- HEADER -->
        <div class="dialog-header">
          <div class="d-flex align-center">
            <div class="dialog-header-icon">
              <v-icon color="white" size="28">
                mdi-clipboard-list-outline
              </v-icon>
            </div>

            <div class="ml-4">
              <div class="dialog-eyebrow">MANAJEMEN JABATAN</div>

              <div class="dialog-title">Tambah Hasil Kerja Jabatan</div>

              <div class="dialog-subtitle">
                Lengkapi informasi hasil kerja pada jabatan ini.
              </div>
            </div>
          </div>

          <v-btn icon dark class="dialog-close" @click="close_modal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <!-- FORM -->
        <v-card-text class="dialog-content">
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-text-box-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Hasil Kerja</div>

                  <div class="dialog-section-description">
                    Tuliskan hasil kerja jabatan.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Nama Hasil Kerja
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="hk_nama"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  counter
                  hide-details="auto"
                  class="dialog-input"
                />
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Satuan
                  <span class="dialog-required">*</span>
                </label>

                <v-text-field
                  v-model="hk_satuan"
                  outlined
                  dense
                  counter
                  type="number"
                  hide-details="auto"
                  class="dialog-input"
                />
              </div>
            </div>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="dialog-footer">
          <div class="dialog-footer-note">
            <v-icon size="17" color="grey"> mdi-information-outline </v-icon>

            <span> Pastikan seluruh data sudah benar. </span>
          </div>

          <v-spacer />

          <v-btn
            depressed
            outlined
            color="grey darken-1"
            class="text-none dialog-cancel-btn"
            :disabled="loading"
            @click="close_modal"
          >
            Batal
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="text-none dialog-submit-btn"
            :loading="loading"
            :disabled="loading"
            @click="add"
          >
            <v-icon left size="18"> mdi-content-save-outline </v-icon>

            Simpan Data
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";
import SData from "@/store/anjab/infojabatan/haskerjab";

import "@/assets/styles/pages/anjab/infojabatan/haskerjab/view.css";

export default {
  data() {
    return {
      token: "",
      session: "",
      lbtn: false,
      loading: false,

      valid: true,

      hk_nama: "",
      hk_satuan: "",
    };
  },

  computed: {
    modal_add: {
      get() {
        return SData.state.modal_add;
      },

      set(value) {
        if (!value) {
          this.close_modal();
        }
      },
    },

    item() {
      return SData.state.data;
    },
  },

  watch: {
    async modal_add(value) {
      if (value) {
        this.token = await cookie.get("token");
      }
    },
  },

  methods: {
    async add() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        return;
      }

      this.loading = true;

      const data = {
        jab_id: this.$route.params.id,
        hk_nama: this.hk_nama,
        hk_satuan: this.hk_satuan,
      };

      const url = `${process.env.VUE_APP_API}/haskerjab/add`;

      this.axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Berhasil Menambah Data");
            SData.commit("alert_b", true);
            SData.commit("alert_g", false);
          } else {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Gagal Menambah Data");
            SData.commit("alert_g", true);
            SData.commit("alert_b", false);
          }

          this.close_modal();
        })
        .catch((error) => {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Gagal Menambah Data");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.loading = false;

          this.close_modal();
        });
    },

    close_modal() {
      SData.commit("close_add", false);

      this.pk_nama = "";
      this.pk_penggunaan = "";

      this.loading = false;
      this.valid = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
